var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import capitalize from "@material-ui/core/utils/capitalize";
import { Box } from "../box";
import { makeStyles } from "../styles";
import clsx from "../utils/clsx";
import { getCosmosDataProps } from "../utils/comsosCompat";
export var LabelComponentName = "QuantumLabel";
export var getDefaultLabelStyles = function (theme, color) { return ({
    background: theme.mixins.shadeOfColor(color, "lightest"),
    color: theme.mixins.textColorForShadeOfColor(color, "lightest"),
}); };
export var getOutlinedLabelStyles = function (theme, options) { return ({
    boxShadow: theme.mixins.borderAsBoxShadow(theme.mixins.shadeOfColor(options.color, options.border)),
    color: theme.mixins.shadeOfColor(options.color, options.text),
}); };
export var useLabelStyles = makeStyles(function (theme) { return ({
    root: __assign(__assign(__assign({}, theme.typography.overline), { padding: theme.spacing(0.125, 0.75), borderRadius: 4, display: "inline-block", verticalAlign: "middle" }), getDefaultLabelStyles(theme, "neutral")),
    defaultPrimary: {
        background: theme.palette.primary[50],
        color: theme.palette.primary[900],
    },
    defaultInfo: getDefaultLabelStyles(theme, "blue"),
    defaultWarning: getDefaultLabelStyles(theme, "yellow"),
    defaultSuccess: getDefaultLabelStyles(theme, "green"),
    defaultError: getDefaultLabelStyles(theme, "red"),
    outlined: {
        backgroundColor: "transparent",
        color: theme.palette.text.primary,
        boxShadow: theme.mixins.borderAsBoxShadow(theme.mixins.shadeOfColor("neutral", "base")),
    },
    outlinedPrimary: {
        boxShadow: theme.mixins.borderAsBoxShadow(theme.palette.primary[800]),
        color: theme.palette.primary[800],
    },
    outlinedInfo: getOutlinedLabelStyles(theme, { color: "blue", text: "base", border: "light" }),
    outlinedWarning: getOutlinedLabelStyles(theme, { color: "yellow", text: "darker", border: "dark" }),
    outlinedSuccess: getOutlinedLabelStyles(theme, { color: "green", text: "dark", border: "base" }),
    outlinedError: getOutlinedLabelStyles(theme, { color: "red", text: "base", border: "light" }),
    filled: {
        backgroundColor: theme.mixins.shadeOfColor("neutral", "dark"),
        color: "#fff",
    },
    filledPrimary: {
        backgroundColor: theme.palette.primary.main,
    },
    filledInfo: {
        backgroundColor: theme.palette.info.main,
    },
    filledWarning: {
        backgroundColor: theme.mixins.shadeOfColor("yellow", "darker"),
    },
    filledSuccess: {
        backgroundColor: theme.mixins.shadeOfColor("green", "darker"),
    },
    filledError: {
        backgroundColor: theme.palette.error.main,
    },
}); }, { name: LabelComponentName });
export var Label = React.forwardRef(function (props, ref) {
    var classes = useLabelStyles(props);
    var _a = props.color, color = _a === void 0 ? "default" : _a, _b = props.variant, variant = _b === void 0 ? "default" : _b, _c = props.component, component = _c === void 0 ? "span" : _c, className = props.className, children = props.children, 
    // remove to prevent passing through to the root
    propClasses = props.classes, boxProps = __rest(props, ["color", "variant", "component", "className", "children", "classes"]);
    return (React.createElement(Box, __assign({ className: clsx([classes.root, classes[variant], classes["" + variant + capitalize(color)], className]), component: component }, getCosmosDataProps("label"), { ref: ref }, boxProps), children));
});
